import React, { Component, useState } from 'react';
import CustomImage from '../../components/custom-image';

const PeoplePractices = () => {
  return (
    <div className="awards-content buttom-section">
      <div className="one-col">
        <h4>People Practices</h4>
        <div className="table-wrapper">
          <div className="desktop-img">
            <CustomImage
              className="icon-arrow-up"
              imageName="people-practices.png"
              alt="People Practices"
              maxWidth="895"
            />
          </div>
          <div className="mobile-img">
            <div className="table-img">
              <CustomImage
                className="icon-arrow-up"
                imageName="people-practices-mobile.png"
                alt="People Practices"
                maxWidth="895"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeoplePractices;
